import React from 'react';
import DarkModeOutlinedIcon from '@mui/icons-material/DarkModeOutlined';
import LightModeOutlinedIcon from '@mui/icons-material/LightModeOutlined';

import { useNewResultsTheme } from '../../hooks/useNewResultsTheme';

export default function NewResultsThemeToggle() {
	const { toggleTheme, isDark } = useNewResultsTheme();

	return (
		<button
			type="button"
			className="new-results-theme-toggle"
			onClick={toggleTheme}
			aria-label={isDark ? 'Passer en mode clair' : 'Passer en mode sombre'}
			title={isDark ? 'Mode clair' : 'Mode sombre'}
		>
			{isDark ? <LightModeOutlinedIcon fontSize="small" /> : <DarkModeOutlinedIcon fontSize="small" />}
		</button>
	);
}
